import arrayShuffle from 'array-shuffle';

const User = (data) => {
    return arrayShuffle(data);
}

export default User;